import { SubMenuList } from '../sub-menu-list';

export class DocumentsListButton extends SubMenuList {
  name = 'documents-list';
}